import { render } from "./OpacityBg.vue?vue&type=template&id=1bf2e1c4"
import script from "./OpacityBg.vue?vue&type=script&lang=js"
export * from "./OpacityBg.vue?vue&type=script&lang=js"

import "./OpacityBg.vue?vue&type=style&index=0&id=1bf2e1c4&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__